<template>
    <div class="e-card e-rounding shadow-sm">
      <PremiumBanner/>
        <h1 class="h3">{{ $t('title.devicesInfo') }}</h1>

      <p class="text-muted mb-3">{{ $t('device.multiDeviceInfo') }}</p>

      <div class="device-modes-info mb-4">
        <div class="device-modes-info__item" v-for="mode in ['cashRegister','customerDisplay','ordersDisplay','orderReadyScreen','barcodeScanner','kiosk']" :key="mode">
          <div class="device-modes-info__icon" v-html="deviceModeSvg(mode)"></div>
          <div>
            <div class="device-modes-info__label">{{ $t('deviceMode.label.' + mode) }}</div>
            <div class="device-modes-info__desc">{{ $t('deviceMode.desc.' + mode) }}</div>
          </div>
        </div>
      </div>

      <div class="d-flex mb-2 justify-content-md-end justify-content-center" v-show="showAddDeviceInfo===false">
        <button v-if="rightCompanySettings" @click="showAddDeviceInfo=true" class="btn btn-primary m-2">
          <i class="fas fa-plus pr-1"></i> {{ $t('button.newDevice') }}
        </button>
      </div>

      <div class="e-card-backdrop" v-if="showAddDeviceInfo===true">
        <div class="row e-modal-row justify-content-center align-items-start">
          <div class="e-modal-card col-10 col-lg-5 bg-white shadow-sm e-rounding p-0">
            <div class="card-header e-user__header">
              <span>{{$t('device.download')}}</span>
              <i @click="showAddDeviceInfo = false" class="fas fa-times e-modal-close-icon"></i>
            </div>
            <div class="card-body py-5 px-4">
              <div style="margin: 20px">
          <img v-if="$i18n.locale === 'cs'" style="margin-left: auto; margin-right: auto; display: block;" src="./../assets/screen/cs-calculator-frame.png" width="100" height="200">
          <img v-if="$i18n.locale === 'en'" style="margin-left: auto; margin-right: auto; display: block;" src="./../assets/screen/en-calculator-frame.png" width="50" height="100">
          <img v-if="$i18n.locale === 'es'" style="margin-left: auto; margin-right: auto; display: block;" src="./../assets/screen/es-calculator-frame.png" width="50" height="100">
              </div>
           <ol>
             <li><a :href="$t('device.downloadUrl')"  target="_blank">{{$t('device.download')}}</a>.</li>
             <li>{{ $t('device.userNameInfo')}}: <b>{{ getUserName() }}</b></li>
             <li> {{ $t('device.info3')}}</li>
           </ol>
              <div class="d-flex flex-wrap-reverse justify-content-center pt-3">
                <div class="e-btn-mobile-container">
                  <a :href="$t('device.downloadUrl')" class="btn btn-primary" target="_blank">{{$t('button.download')}}</a>
                </div>
              </div>
        </div>
          </div>
        </div>
      </div>
        <Loader v-if="loading" />                
                
        <div v-if="!loading" class="row">
            <div class="col-12 col-lg-6 mt-2 mb-2" v-for="device in devices" v-bind:key="device.deviceId">
                <div class="device-card shadow-sm e-rounding" :class="{ 'device-card--inactive': !device.active }">

                  <!-- Icon banner -->
                  <div class="device-card__banner" :class="{ 'device-card__banner--inactive': !device.active }">
                    <div class="device-card__mode-icon" v-html="deviceModeSvg(device.deviceMode, device.type==='virtual')"></div>
                    <div class="device-card__banner-text">
                      <div class="device-card__mode-label">{{ $t('deviceMode.label.' + device.deviceMode) }}
                        <span v-if="device.type==='virtual'" class="device-card__virtual-tag">({{ $t('device.virtual') }})</span></div>
                      <div class="device-card__name">{{ device.name }}</div>
                      <div class="device-card__badges">
                        <span v-if="!device.active" class="badge badge-secondary">{{ $t('text.inactive') }}</span>
                        <span v-else-if="device.oldVersion" class="badge badge-danger" v-tooltip="$t('warning.oldVersion')">
                          <i class="fa-solid fa-triangle-exclamation mr-1"></i>{{ $t('warning.oldVersion') }}
                        </span>
                        <span v-else-if="device.synced" class="badge badge-success" v-tooltip="$t('tooltip.deviceAllUpdated')">
                          <i class="fas fa-check mr-1"></i>{{ $t('text.deviceAllUpdated') }}
                        </span>
                        <span v-else class="badge badge-warning" v-tooltip="$t('tooltip.deviceNotUpdated')">
                          <i class="fas fa-plug mr-1"></i>{{ $t('text.deviceNotUpdated') }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- Info grid -->
                  <div class="device-card__body">
                    <div class="device-card__grid">
                      <div class="device-card__field">
                        <div class="device-card__label">{{ $t('deviceMode.title') }}</div>
                        <div class="device-card__value">{{ $t('deviceMode.label.' + device.deviceMode) }}</div>
                      </div>
                      <div v-if="device.type !== 'virtual'" class="device-card__field">
                        <div class="device-card__label">{{ $t('form.appVersion') }}</div>
                        <div class="device-card__value" :class="{ 'text-danger': device.oldVersion && device.active }">{{ device.appVersion }}</div>
                      </div>
                      <div v-if="device.type !== 'virtual'" class="device-card__field">
                        <div class="device-card__label">{{ $t('form.ownerUserName') }}</div>
                        <div class="device-card__value">{{ device.ownerUserName }}</div>
                      </div>
                      <div v-if="device.type !== 'virtual'" class="device-card__field">
                        <div class="device-card__label">{{ $t('form.deviceLastUsed') }}</div>
                        <div class="device-card__value">
                          <span v-if="device.lastUsed !== null">{{ $d(new Date(Date.parse(device.lastUsed)), 'short') }}</span>
                          <span v-else class="text-muted">—</span>
                        </div>
                      </div>
                      <div v-if="device.deviceMode === 'cashRegister'" class="device-card__field">
                        <div class="device-card__label">{{ $t('form.cashRegister') }}</div>
                        <div class="device-card__value">{{ device.cashRegister }}</div>
                      </div>
                      <div v-if="device.type !== 'virtual'" class="device-card__field" :class="device.deviceMode === 'cashRegister' ? '' : 'device-card__field--wide'">
                        <div class="device-card__label">{{ $t('device.allowed_users') }}</div>
                        <div class="device-card__value">
                          <span v-for="(au, index) in device.allowedUsers" v-bind:key="au.userId">
                            <span v-if="index !== 0">, </span>{{ au.userName }}
                          </span>
                          <span v-if="!device.allowedUsers || device.allowedUsers.length === 0" class="text-muted">—</span>
                        </div>
                      </div>
                    </div>

                    <!-- Actions -->
                    <div class="device-card__actions">
                      <div class="d-flex">
                        <template v-if="device.deviceMode === 'cashRegister' && device.type !== 'virtual'">
                          <button class="btn btn-secondary btn-sm mr-1" @click="cashJournalOffset=0; readCashJournal(device.deviceId)">
                            <i class="fas fa-coins mr-1"></i>{{ $t('button.cashLog') }}
                          </button>
                          <button class="btn btn-secondary btn-sm mr-1" @click="showShifts = true; deviceId = device.deviceId">
                            <i class="fas fa-chart-bar mr-1"></i>{{ $t('shift.shiftsAndReports') }}
                          </button>
                        </template>
                      </div>
                      <button v-if="rightCompanySettings" @click="prepareEditDevice(device.deviceId)" class="btn btn-secondary btn-sm">
                        <i class="fas fa-pen mr-1"></i>{{ $t('button.editDevice') }}
                      </button>
                    </div>
                  </div>

                </div>
            </div>
        </div>

      <div class="e-card-backdrop" v-if="!loading && showEditDevice">
        <div class="row e-modal-row justify-content-center align-items-start">
          <div class="e-modal-card col-10 col-lg-6 bg-white shadow-sm e-rounding p-0">
            <div class="card-header e-user__header">
              <span>{{ $t('button.editDevice') }}</span>
              <i @click="showEditDevice = false" class="fas fa-times e-modal-close-icon"></i>
            </div>
            <div class="card-body py-5 px-4">
              <form>
                <div class="form-group mb-4">
                  <label for="deviceName">{{ $t('form.deviceName') }}</label>
                  <input v-model="device.name" class="form-control" id="deviceName">
                </div>
              </form>
              <div v-if="device.type !== 'virtual'">
                <p></p>
                <b>{{ $t('device.allowed_users')}}:</b>
                <div v-for="user in device.users" v-bind:key="user.userId">
                  <input type="checkbox"  v-model="user.allowedForDevice" /> {{ user.userName}}
                </div>
              </div>
              <div class="d-flex flex-wrap-reverse justify-content-between pt-3">
                <div>
                  <button v-if="device.active" @click="deactivateDevice(device.deviceId)" class="btn btn-danger mr-4">
                    {{ $t('button.deactivateDevice') }}
                  </button>
                </div>
                <div class="e-btn-mobile-container">
                  <button @click="showEditDevice = false" class="btn btn-outline-secondary mr-4">
                    {{ $t('button.back')}}
                  </button>
                  <button @click="editDevice()" class="btn btn-primary">
                    {{ $t('button.save') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="e-card-backdrop" v-if="!loading && showCashJournal">
        <div class="row e-modal-row justify-content-center align-items-start">
          <div class="e-modal-card col-10 col-lg-6 bg-white shadow-sm e-rounding p-0">
            <div class="card-header e-user__header">
              <span>{{ $t('button.cashLog') }}</span>
              <i @click="showCashJournal = false" class="fas fa-times e-modal-close-icon"></i>
            </div>
            <div class="card-body py-5 px-4">
              <h3>{{ $t('cash.actual') }}: {{ cash.actualInCash }}</h3>
              <div v-for="val in cash.actualInCashCurrencies" v-bind:key="val">{{ val }}</div>
              <p></p>
              <table class="table table-hover e-table--responsive">
                <thead>
                <tr>
                  <th>{{ $t('cash.date') }}</th>
                  <th style="text-align: right;">{{ $t('cash.amount') }}</th>
                  <th>{{ $t('cash.user') }}</th>
                  <th>{{ $t('cash.note') }}</th>
                </tr>
                </thead>
                <tbody>
                  <tr v-for="cr in cash.cashRecords" v-bind:key="cr.cardRecordId">
                    <td :data-title="$t('cash.date')">{{$d(new Date(Date.parse(cr.dateTime)),'short')}}</td>
                    <td :data-title="$t('cash.amount')" style="text-align: right;">
                    <span v-if="cr.amount <0" class="amount_negative">{{ cr.amountStr }} </span>
                    <span v-if="cr.amount >0" class="amount_positive">{{ cr.amountStr }} </span>
                    <span v-if="cr.amount === 0" class="amount_zero">{{ cr.amountStr }} </span>
                    </td>
                    <td :data-title="$t('cash.user')">{{ cr.userName }}</td>
                    <td :data-title="$t('cash.note')">{{ cr.note }}</td>
                  </tr>
                </tbody>
              </table>

              <div v-if="cash.previous!==null || cash.next!==null">
              <span v-if="cash.previous!==null"><a href="#" @click="cashJournalOffset=cash.previous;readCashJournal(cash.deviceId)">{{ $t('button.previous') }}</a></span>
              <span v-else>{{ $t('button.previous') }}</span>
              &nbsp;
              <span v-if="cash.next!==null"><a href="#" @click="cashJournalOffset=cash.next;readCashJournal(cash.deviceId)">{{ $t('button.next') }}</a></span>
              <span v-else>{{ $t('button.next') }}</span>
              </div>

              <div class="d-flex flex-wrap-reverse justify-content-between pt-3">
                <div class="e-btn-mobile-container">
                  <button @click="showCashJournal = false" class="btn btn-outline-secondary mr-4">
                    {{ $t('button.back')}}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Shifts v-if="showShifts" :device-id="deviceId" @closeShifts="showShifts=false"/>

    </div>
</template>

<script>
    import Loader from "@/components/Loader"
    import Shifts from "@/components/Shifts"
    import rightUtil from "@/util/rights"
    import PremiumBanner from "@/components/PremiumBanner.vue";

    export default {
        name: 'Devices',
        components: {PremiumBanner, Loader, Shifts },

        data: function () {
            return {
                devices: [],
                device: {
                },
                cash: {
                },
                showEditDevice: false,
                showCashJournal: false,
                loading: true,
                showAddDeviceInfo: false,
                showShifts: false,
                deviceId: null,
                rightCompanySettings: false,
                cashJournalOffset: 0
            }
        },

        mounted: function () {
            this.setupRefresh();

            this.rightCompanySettings = rightUtil.hasRight(rightUtil.codes.companySettings);
        },

        destroyed: function() {
            clearInterval(this.inl);
        },

        methods: {
            refresh: function(loadingStatus) {
                const vm = this;
                vm.loading = loadingStatus;
                this.$http.post('/device/get-devices')
                    .then(function (response) {
                        vm.loading = false;
                        vm.devices = response.data.devices.sort((a, b) => a.name.localeCompare(b.name));
                    });
            },
          deactivateDevice: function(deviceId) {
            this.$modal.cs_confirm(this.$t('warning.deactivateDevice'),()=>{
              const vm = this;
              vm.loading = true;
              this.$http.post('/device/deactivate-device',{deviceId: deviceId})
                  .then(function () {
                    vm.showEditDevice = false;
                    vm.refresh(true);
                  });
            });
          },
          setupRefresh: function() {
            this.refresh(true);

            //setup periodic refresh
            this.inl = setInterval(() => {
              this.refresh(false);
            }, 4000);
          },
          getUserName: function () {
              return localStorage.userName;
          },
          readCashJournal: function(deviceId) {
            const vm = this;
            vm.loading = true;
            this.$http.post('/cash/get-cash-records',{
              deviceId:deviceId,
              offset: vm.cashJournalOffset
            })
                .then(function (response) {
                  vm.loading = false;
                  vm.cash = response.data;
                  vm.showCashJournal = true;
                });
          },
          prepareEditDevice: function (deviceId) {
            const vm = this;
            vm.loading = true;
            this.$http.post('/device/get-device',{deviceId:deviceId})
                .then(function (response) {
                  vm.loading = false;
                  vm.device = response.data;
                  vm.showEditDevice = true;
                });
          },
          deviceModeSvg: function(mode, isVirtual) {
            if (isVirtual) mode = 'virtual';
            const svgs = {
              cashRegister: `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="15" y="5" width="14" height="11" rx="2" fill="#1e3d7a"/>
                <rect x="6" y="14" width="30" height="20" rx="3" fill="#3a6abf"/>
                <rect x="9" y="17" width="19" height="13" rx="2" fill="#1e3d7a"/>
                <rect x="10" y="18" width="17" height="11" rx="1" fill="#dde8f8"/>
                <rect x="12" y="21" width="11" height="1.5" rx="0.5" fill="#3a6abf" opacity="0.5"/>
                <rect x="12" y="24" width="8" height="1.5" rx="0.5" fill="#3a6abf" opacity="0.5"/>
                <rect x="30" y="17" width="4" height="3" rx="1" fill="#dde8f8"/>
                <rect x="30" y="21" width="4" height="3" rx="1" fill="#dde8f8"/>
                <rect x="30" y="25" width="4" height="3" rx="1" fill="#4caf50"/>
                <rect x="4" y="34" width="34" height="6" rx="2" fill="#1e3d7a"/>
                <rect x="16" y="36" width="10" height="2" rx="1" fill="#3a6abf"/>
              </svg>`,
              ordersDisplay: `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="6" width="40" height="28" rx="3" fill="#1e3d7a"/>
                <rect x="7" y="9" width="34" height="22" rx="1.5" fill="#dde8f8"/>
                <rect x="9" y="11" width="14" height="18" rx="2" fill="white"/>
                <rect x="11" y="14" width="8" height="1.5" rx="0.5" fill="#3a6abf"/>
                <rect x="11" y="17" width="6" height="1" rx="0.5" fill="#aaa" opacity="0.7"/>
                <rect x="11" y="19" width="8" height="1" rx="0.5" fill="#aaa" opacity="0.7"/>
                <rect x="11" y="21" width="5" height="1" rx="0.5" fill="#aaa" opacity="0.7"/>
                <rect x="11" y="24" width="10" height="2.5" rx="1" fill="#4caf50"/>
                <rect x="25" y="11" width="14" height="18" rx="2" fill="white"/>
                <rect x="27" y="14" width="8" height="1.5" rx="0.5" fill="#3a6abf"/>
                <rect x="27" y="17" width="6" height="1" rx="0.5" fill="#aaa" opacity="0.7"/>
                <rect x="27" y="19" width="8" height="1" rx="0.5" fill="#aaa" opacity="0.7"/>
                <rect x="27" y="21" width="5" height="1" rx="0.5" fill="#aaa" opacity="0.7"/>
                <rect x="22" y="34" width="4" height="6" rx="1" fill="#1e3d7a"/>
                <rect x="15" y="38" width="18" height="3" rx="1.5" fill="#1e3d7a"/>
              </svg>`,
              customerDisplay: `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="5" width="40" height="28" rx="3" fill="#1e3d7a"/>
                <rect x="7" y="8" width="34" height="22" rx="1.5" fill="#dde8f8"/>
                <rect x="9" y="10" width="30" height="5" rx="1" fill="#3a6abf"/>
                <rect x="16" y="11.5" width="16" height="2" rx="1" fill="white" opacity="0.6"/>
                <rect x="9" y="17" width="18" height="1.5" rx="0.5" fill="#3a6abf" opacity="0.5"/>
                <rect x="9" y="20" width="14" height="1.5" rx="0.5" fill="#3a6abf" opacity="0.5"/>
                <rect x="9" y="23" width="16" height="1.5" rx="0.5" fill="#3a6abf" opacity="0.5"/>
                <rect x="29" y="17" width="12" height="9" rx="1.5" fill="#3a6abf"/>
                <rect x="31" y="19" width="8" height="1.5" rx="0.5" fill="white" opacity="0.5"/>
                <rect x="30" y="22" width="10" height="2.5" rx="0.5" fill="white" opacity="0.85"/>
                <rect x="22" y="33" width="4" height="7" rx="1" fill="#1e3d7a"/>
                <rect x="15" y="38" width="18" height="3" rx="1.5" fill="#1e3d7a"/>
              </svg>`,
              kiosk: `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="14" y="43" width="20" height="4" rx="2" fill="#1e3d7a"/>
                <rect x="22" y="31" width="4" height="14" rx="1" fill="#1e3d7a"/>
                <rect x="10" y="5" width="28" height="28" rx="4" fill="#1e3d7a"/>
                <rect x="13" y="8" width="22" height="22" rx="2" fill="#dde8f8"/>
                <rect x="15" y="10" width="18" height="5" rx="1" fill="#3a6abf"/>
                <rect x="19" y="11.5" width="10" height="2" rx="1" fill="white" opacity="0.6"/>
                <rect x="15" y="17" width="8" height="6" rx="1.5" fill="#3a6abf" opacity="0.7"/>
                <rect x="25" y="17" width="8" height="6" rx="1.5" fill="#3a6abf" opacity="0.7"/>
                <rect x="17" y="25" width="14" height="3" rx="1.5" fill="#4caf50"/>
              </svg>`,
              barcodeScanner: `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="16" y="4" width="16" height="22" rx="4" fill="#1e3d7a"/>
                <rect x="19" y="8" width="10" height="8" rx="1.5" fill="#dde8f8"/>
                <rect x="17" y="11" width="14" height="2" rx="1" fill="#e53935" opacity="0.85"/>
                <rect x="19" y="19" width="10" height="4" rx="1" fill="#3a6abf"/>
                <path d="M20 26 Q17 34 18 41 L30 41 Q31 34 28 26 Z" fill="#1e3d7a"/>
                <rect x="21" y="34" width="6" height="3" rx="1.5" fill="#3a6abf"/>
                <rect x="7" y="43" width="2" height="5" rx="0.5" fill="#333"/>
                <rect x="11" y="43" width="3" height="5" rx="0.5" fill="#333"/>
                <rect x="16" y="43" width="1.5" height="5" rx="0.5" fill="#333"/>
                <rect x="19" y="43" width="3" height="5" rx="0.5" fill="#333"/>
                <rect x="24" y="43" width="1.5" height="5" rx="0.5" fill="#333"/>
                <rect x="27" y="43" width="3" height="5" rx="0.5" fill="#333"/>
                <rect x="32" y="43" width="2" height="5" rx="0.5" fill="#333"/>
                <rect x="36" y="43" width="3" height="5" rx="0.5" fill="#333"/>
              </svg>`,
              orderReadyScreen: `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="5" width="40" height="28" rx="3" fill="#1e3d7a"/>
                <rect x="7" y="8" width="34" height="22" rx="1.5" fill="#dde8f8"/>
                <rect x="9" y="10" width="30" height="4" rx="1" fill="#3a6abf"/>
                <rect x="11" y="11.5" width="14" height="1.5" rx="0.5" fill="white" opacity="0.7"/>
                <rect x="9" y="16" width="13" height="5" rx="1.5" fill="white"/>
                <rect x="11" y="17.5" width="5" height="1.5" rx="0.5" fill="#3a6abf"/>
                <rect x="11" y="20" width="8" height="1" rx="0.5" fill="#4caf50"/>
                <rect x="24" y="16" width="13" height="5" rx="1.5" fill="white"/>
                <rect x="26" y="17.5" width="5" height="1.5" rx="0.5" fill="#3a6abf"/>
                <rect x="26" y="20" width="8" height="1" rx="0.5" fill="#ffc107"/>
                <rect x="9" y="23" width="13" height="5" rx="1.5" fill="white"/>
                <rect x="11" y="24.5" width="5" height="1.5" rx="0.5" fill="#3a6abf"/>
                <rect x="11" y="27" width="8" height="1" rx="0.5" fill="#4caf50"/>
                <rect x="24" y="23" width="13" height="5" rx="1.5" fill="white"/>
                <rect x="26" y="24.5" width="5" height="1.5" rx="0.5" fill="#3a6abf"/>
                <rect x="26" y="27" width="8" height="1" rx="0.5" fill="#e53935"/>
                <rect x="22" y="33" width="4" height="7" rx="1" fill="#1e3d7a"/>
                <rect x="15" y="38" width="18" height="3" rx="1.5" fill="#1e3d7a"/>
              </svg>`,
              virtual: `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <!-- QR background -->
                <rect x="4" y="4" width="40" height="40" rx="4" fill="white"/>
                <!-- QR finder: top-left -->
                <rect x="7" y="7" width="12" height="12" rx="1.5" fill="#1e3d7a"/>
                <rect x="9" y="9" width="8" height="8" rx="0.8" fill="white"/>
                <rect x="11" y="11" width="4" height="4" rx="0.5" fill="#1e3d7a"/>
                <!-- QR finder: top-right -->
                <rect x="29" y="7" width="12" height="12" rx="1.5" fill="#1e3d7a"/>
                <rect x="31" y="9" width="8" height="8" rx="0.8" fill="white"/>
                <rect x="33" y="11" width="4" height="4" rx="0.5" fill="#1e3d7a"/>
                <!-- QR finder: bottom-left -->
                <rect x="7" y="29" width="12" height="12" rx="1.5" fill="#1e3d7a"/>
                <rect x="9" y="31" width="8" height="8" rx="0.8" fill="white"/>
                <rect x="11" y="33" width="4" height="4" rx="0.5" fill="#1e3d7a"/>
                <!-- QR data dots -->
                <rect x="22" y="7" width="3" height="3" rx="0.5" fill="#1e3d7a"/>
                <rect x="22" y="12" width="3" height="3" rx="0.5" fill="#1e3d7a"/>
                <rect x="7" y="22" width="3" height="3" rx="0.5" fill="#1e3d7a"/>
                <rect x="12" y="22" width="3" height="3" rx="0.5" fill="#1e3d7a"/>
                <rect x="22" y="22" width="3" height="3" rx="0.5" fill="#1e3d7a"/>
                <rect x="27" y="22" width="3" height="3" rx="0.5" fill="#1e3d7a"/>
                <rect x="32" y="22" width="3" height="3" rx="0.5" fill="#1e3d7a"/>
                <rect x="38" y="22" width="3" height="3" rx="0.5" fill="#1e3d7a"/>
                <rect x="27" y="27" width="3" height="3" rx="0.5" fill="#1e3d7a"/>
                <rect x="33" y="27" width="3" height="3" rx="0.5" fill="#1e3d7a"/>
                <rect x="22" y="32" width="3" height="3" rx="0.5" fill="#1e3d7a"/>
                <rect x="27" y="32" width="3" height="3" rx="0.5" fill="#1e3d7a"/>
                <rect x="33" y="33" width="3" height="3" rx="0.5" fill="#1e3d7a"/>
                <rect x="38" y="27" width="3" height="3" rx="0.5" fill="#1e3d7a"/>
                <rect x="38" y="33" width="3" height="3" rx="0.5" fill="#1e3d7a"/>
                <rect x="22" y="38" width="3" height="3" rx="0.5" fill="#1e3d7a"/>
                <rect x="33" y="38" width="3" height="3" rx="0.5" fill="#1e3d7a"/>
              </svg>`,
            };
            return svgs[mode] || svgs['cashRegister'];
          },
          editDevice: function () {
            const vm = this;
            //prepare users
            let allowedUsers = [];
            for(let i=0; i<vm.device.users.length; i++) {
              const user = vm.device.users[i];
              if(user.allowedForDevice === true) {
                allowedUsers.push(user.userId);
              }
            }
            this.$http.post('/device/update-device',{
              deviceId: vm.device.deviceId,
              name: vm.device.name,
              allowedUsers: allowedUsers
            }).then(function () {
                  vm.showEditDevice = false;
                  vm.refresh();
                });
          }
        }
    }

</script>

<style>
  /* Device card */
  .device-card {
    background: #fff;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .device-card--inactive {
    opacity: 0.6;
  }

  /* Banner */
  .device-card__banner {
    background: #f0f0f0;
    color: #212529;
    padding: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    border-bottom: 1px solid #e0e0e0;
  }
  .device-card__banner--inactive {
    background: #f8f8f8;
    color: #aaa;
  }
  .device-card__mode-icon {
    width: 76px;
    height: 76px;
    min-width: 76px;
    background: rgba(0,0,0,0.07);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    padding: 10px;
  }
  .device-card__mode-icon svg {
    width: 100%;
    height: 100%;
  }
  .device-card__banner-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    min-width: 0;
  }
  .device-card__mode-label {
    font-size: 0.8rem;
    color: #666;
    margin-bottom: 2px;
  }
  .device-card__name {
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 6px;
  }

  /* Mode info list */
  .device-modes-info {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 12px;
  }
  .device-modes-info__item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    background: #f8f8f8;
    border-radius: 8px;
    padding: 12px 14px;
  }
  .device-modes-info__icon {
    width: 44px;
    height: 44px;
    background: #e8e8e8;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    padding: 5px;
    overflow: hidden;
  }
  .device-modes-info__icon svg {
    width: 100%;
    height: 100%;
  }
  .device-modes-info__label {
    font-weight: 600;
    font-size: .9rem;
    margin-bottom: 2px;
  }
  .device-modes-info__desc {
    font-size: 0.82rem;
    color: #666;
  }
  .device-card__virtual-tag {
    display: inline-block;
    margin-left: 6px;
    font-size: 0.72rem;
    font-weight: 600;
    color: #5a7fc7;
    background: #e8eef8;
    border-radius: 4px;
    padding: 1px 6px;
    vertical-align: middle;
  }
  .device-card__badges .badge {
    font-size: 0.8rem;
    padding: 4px 10px;
  }

  /* Body */
  .device-card__body {
    padding: 18px 20px 16px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .device-card__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px 20px;
    margin-bottom: 16px;
  }
  .device-card__field--wide {
    grid-column: span 2;
  }
  .device-card__label {
    font-weight: 600;
    font-size: .9rem;
    margin-bottom: 2px;
  }
  .device-card__value {
    margin-bottom: 0;
  }

  /* Actions */
  .device-card__actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #f0f0f0;
    padding-top: 12px;
    flex-wrap: nowrap;
    overflow: hidden;
  }
  .device-card__actions .btn {
    white-space: nowrap;
    flex-shrink: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* Cash journal amounts */
  .amount_positive { color: green; font-weight: bold; }
  .amount_negative { color: red; font-weight: bold; }
  .amount_zero     { color: black; font-weight: bold; }

  @media (max-width: 576px) {
    .device-card__banner {
      padding: 14px;
      gap: 12px;
    }
    .device-card__mode-icon {
      width: 60px;
      height: 60px;
      min-width: 60px;
    }
    .device-card__body {
      padding: 14px 14px 12px;
    }
    .device-card__grid {
      grid-template-columns: 1fr;
    }
    .device-card__field--wide {
      grid-column: span 1;
    }
    .device-card__actions {
      flex-wrap: wrap;
      gap: 8px;
    }
    .device-card__actions > div {
      flex: 1 1 auto;
    }
    .device-card__actions > div .btn {
      flex: 1;
    }
  }
</style>